module.exports = __webpack_public_path__ + "img/rear.56d30575.png";